import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
/**
 * ANALYTICS — inyectado en el punto de arranque más temprano del sitio.
 *
 * Magic Patterns sirve la landing como una SPA: el HTML publicado es sólo
 * <div id="root"></div> + el bundle de JS, por lo que NO existe un <head>
 * estático editable. Este archivo (index.tsx) es el primer código que el
 * navegador ejecuta — antes de que React monte la App — así que es el lugar
 * equivalente al HEAD para garantizar que el Pixel dispare lo antes posible
 * y sea detectable por Meta Pixel Helper.
 *
 * META PIXEL ID: 1369612068384467
 * MICROSOFT CLARITY ID: x7ywaz7ne7
 */
const META_PIXEL_ID = '1369612068384467';
const CLARITY_PROJECT_ID = 'x7ywaz7ne7';
(function initMetaPixel() {
  if (typeof window === 'undefined') return;
  try {
    ;
    (function (f: any, b, e, v, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    (window as any).fbq('init', META_PIXEL_ID);
    (window as any).fbq('track', 'PageView');
    // <noscript> fallback — replica del pixel oficial para fuentes sin JS
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=' + META_PIXEL_ID + '&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.head.appendChild(noscript);
  } catch (err) {
    // Nunca dejar que analytics rompa el render
    console.error('Meta Pixel failed to load', err);
  }
})();
(function initClarity() {
  if (typeof window === 'undefined') return;
  try {
    ;
    (function (c: any, l, a, r, i?: any, t?: any, y?: any) {
      c[a] = c[a] || function () {
        ;
        (c[a].q = c[a].q || []).push(arguments);
      };
      t = l.createElement(r);
      t.async = 1;
      t.src = 'https://www.clarity.ms/tag/' + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', CLARITY_PROJECT_ID);
  } catch (err) {
    console.error('Microsoft Clarity failed to load', err);
  }
})();
render(<App data-id="element-519" />, document.getElementById('root'));